import { NgModule } from '@angular/core';
import { IonicPageModule } from 'ionic-angular';
import { UsersPage } from './users';
import { ComponentsModule } from '../../../components/components.module';

@NgModule({
  declarations: [
    UsersPage,
  ],
  imports: [
    IonicPageModule.forChild(UsersPage),
    ComponentsModule
  ],
})
export class UsersPageModule {}



// WEBPACK FOOTER //
// ./src/pages/create-user/users/users.module.ts